<template>
  <div class="all-style-bgc">
    <div class="container">
      <div class="title-tab">
        <span>当前位置：</span>
        <span @click="GoreportInternet">清风论坛></span>
        <span @click="GoreportEvaluation">警示教育></span>
        <span class="red">正文</span>
      </div>
      <!--正文内容-->
      <div class="text">
        <h1>市纪委通报6起违反中央八项规定精神典型案例</h1>
        <h2>
          来源：新华社
          <span class="mg-16">|</span>
          发布时间：2020-03-30&nbsp;13:30
        </h2>
        <h3>端午佳节将至，为进一步巩固拓展落实中央八项规定精神成果，持续发力纠治“四风”，确保我市节日期间风清气正，助力疫情防控常态化条件下各项工作顺利推进，现将近期查处的6起违反中央八项规定精神典型案例通报如下：.11%。从村（社区）干部受处理具体案例来分析，两人或两人以上“抱团”违纪现象比较普遍。主要表现为以村支部书记、主任为核心，其他村组干部参与、共同“谋划”的利益“小团体”，成为违纪违法问题的高危群体。如，该市太平镇崔垱村、大王村从村支部书记到村委会委员，集体挪用粮食直补款、坐收坐支集体资金等，涉及村“两委”干部达5人。+体会交流+廉政党课”的方式召开了“一案一教育”警示教育大会，强化警示教育的感染力和说服力。</h3>
        <h3>
          <b>一、枣阳市教育局二级主任科员曹勇接受服务对象宴请问题</b>
        </h3>
        <h3>2020年1月9日，曹勇在负责枣阳市中兴学校一期工程建设项目期间，接受可能影响公正执行公务的宴请，在工作日饮酒，并在调查期间对抗组织审查。2020年5月，曹勇受到党内严重警告处分。.76%，同比增长7.25%。主要原因是由于各地各单位受理信访举报的时间不同，信访人担心信访件未被受理或重视不够，在等待的过程中重复反映问题，导致重复访数量居高不下。2019年越级访15件次，同比下降57.14%。主要原因是枣阳市纪委监委领导班子认真执行定期下访接访制度，主要领导每周四固定接访，去年共接待群众面访36批次581人次，上访对象无一人越级访，有效缓解了全市大信访压力，越级访乱象得到了遏止；二是自办案件增加，上级转交件下降。2019年共受理信访举报995件，同比基本持平。其中本级自收573件，占57.59%，同比增长57.85%；上级转交办422件，占42.41%，同比下降33.02%。主要原因是随着全面从严治党不断向纵深推进，信访干部履职尽责意识不断增强，办信办访能力增强，加之信访渠道的通畅及日益拓宽，干部主动接访、带案下访、重点约访的机制发挥了积极作用，群众在本级信访诉求能够得到有效解决，越级向上反映问题大幅减少。三是信访反映村级干部增加，乡科级干部减少。2019年信访反映村（社区）人员419件，同比增长16.06%，反映乡科级干部198件，同比下降30.5%。从中不难看出在全面从严治党的高压态势下，不敢腐的震慑已经形成，不能腐的笼子正在扎牢，不想腐的自觉逐步增强，但从村干部信访举报持续增长的趋势显示，全面从严治党“最后一米”的问题还不够彻底，违反群众纪律和廉洁纪律类问题仍然居高不下，破坏了党群干群关系，蚕食了群众切身利益。 闵翼飞）</h3>
        <h3>
          <b>二、谷城县公安局城关派出所党支部委员、副所长、治安中队队长吕军违规收受礼品问题</b>
        </h3>
        <h3>2018年12月至2019年4月，谷城经济开发区某村村民张某某因承包土地与他人发生纠纷，吕军参与调解该纠纷。2019年4月10日下午，张某某的亲属王某某找到吕军，向其赠送了一件15年白云边白酒、两提西班牙威格啤酒。吕军违反中央八项规定精神，收受当事人礼品。2020年4月，吕军受到党内警告处分。</h3>
        <h3>
          <b>三、老河口市疾控中心党支部委员、副主任李安国“精致走账”式公款吃喝问题</b>
        </h3>
        <h3>2017年1月至2018年3月，时任老河口市李楼卫生院院长的李安国安排他人利用空白公函，以虚编公务接待事由，虚列接待对象、接待人数方式，违规报销吃喝费用9292元；以看望住院和困难退休职工名义虚列开支，违规核销吃喝中产生的烟酒费用6000元。2020年2月，李安国受到党内严重警告处分。</h3>
        <h3>
          <b>四、襄城区城管执法大队檀溪中队队员徐春福公车私用问题</b>
        </h3>
        <h3>2019年9月1日，徐春福驾驶城管执法车辆在执勤片区值班。下班后，徐春福未按规定停驶执法车辆，而是应朋友邀约驾车前往就餐，饭后徐春福又驾驶执法车辆送朋友回家，途中发生交通事故，被群众举报。2020年4月，徐春福受到党内严重警告处分。</h3>
        <h3>
          <b>五、宜城市板桥店镇王台村原党支部书记朱学强和党支部委员邹兆亮违规公款吃喝问题</b>
        </h3>
        <h3>2017年至2019年，时任王台村党支部书记朱学强和分管财务的党支部委员邹兆亮，利用某风电公司在该村修路的机会，通过虚列林地资源的方式，先后两次套取企业占地补偿款共计8.15万元，并将其中的5.7万元用于支付王台村在餐馆就餐及购买烟酒费用。2020年4月，朱学强、邹兆亮分别受到党内严重警告处分、党内警告处分。</h3>
        <h3>
          <b>六、老河口市酂阳办事处李家河村原党支部书记、村委会主任李随全违规发放津补贴问题</b>
        </h3>
        <h3>2015至2017年间，经李随全同意，李家河村先后违规向多名离职村干部发放工资、慰问金共计11060元。2020年4月，连同其他违纪问题，李随全受到留党察看一年处分。.15万元，并将其中的5.7万元用于支付王台村在餐馆就餐及购买烟酒费用。2020年4月，朱学强、邹兆亮分别受到党内严重警告处分、党内警告处分。</h3>
        <h3>上述6起违反中央八项规定典型案例，反映了我市在全面从严治党的态势下，仍有少数党员干部不知敬畏，不守规矩，损害了党和政府形象，必须给予高度重视和严肃处理。各级党组织要切实履行全面从严治党主体责任，持续发力整治“四风”，紧盯重要时间节点，密切关注“四风”隐形变异新现象，严防反弹回潮。各级纪检监察机关要紧盯重点领域和薄弱环节，创新监督方式和手段，深挖细查违反中央八项规定精神问题线索，防范和查处违规操办婚丧喜庆、违规发放津补贴等节日易发高发问题。要畅通监督举报渠道，对群众反映强烈的“四风”问题线索和舆情迅速处置应对，对顶风违纪者从严从重查处。</h3>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      PicBannertest1: require("../../../../assets/image/bannertest1.jpg"),
      PicBannertest2: require("../../../../assets/image/bannertest2.jpg")
    };
  },
  methods: {
    GoreportInternet() {
      this.$router.push("/forum");
    },
    GoreportEvaluation() {
      this.$router.push({ name: "forumWarning" });
    }
  }
};
</script>

<style lang="less" scoped>
.container {
  width: 1200px;
  margin: 0 auto;
}
/*副导航兰*/
.title-tab {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 54px;
  cursor: pointer;
}
.red {
  color: red;
}
/*问卷调查正文*/
.text {
  background-color: white;
  padding: 44px 60px 121px 60px;
  margin: 0 auto;
}
.text h1 {
  font-size: 28px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 56px;
  text-align: center;
}
.text h2 {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 44px;
  text-align: center;
  padding-bottom: 14px;
  border-bottom: 1px solid #E8E8E8;
  margin-bottom: 15px;
   text-align: center;
  display: flex;
  justify-content: center;
}
.text h3 {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 32px;
  text-indent: 2em;
  margin-bottom: 30px;
}
/*静态页面样式 */
.PIC-BOX {
  display: flex;
  justify-content: center;
}
.text h3 b {
  display: block;
  margin-top: 20px;
}
img{
  margin: 20px 0px;
}
.mg-16{
  margin: 0px 16px;
}
</style>